<div style="min-height: 500px;">
    <p-messages severity="info">
        <ng-template pTemplate>
        <div class="text-sm text-blue-500 mt-1">
            <i class="pi pi-info-circle mr-1"></i> Note: Lorsqu'un jour du mois est spécifié, le jour de la semaine sera automatiquement défini sur '?' et vice versa.
        </div>
        </ng-template>
    </p-messages>
    <p-tabView [(activeIndex)]="selectedTab">
        <!-- Minutes Tab -->
        <p-tabPanel header="Minutes">
            <div class="flex flex-column gap-2">
                <label>Sélectionnez l'option pour les minutes:</label>
                <div class="flex flex-row gap-2 mt-3" *ngFor="let option of minutesOptions">
                    <p-radioButton [value]="option.value" [(ngModel)]="selectedMinutesOption"
                        [inputId]="'minute_' + option.value" (onClick)="onMinutesChange()">
                    </p-radioButton>
                    <label [for]="'minute_' + option.value">{{ option.label }}</label>
                </div>
                <div class="flex flex-column gap-2 mt-3" *ngIf="selectedMinutesOption === 'custom'">
                    <label>Minute spécifique (0-59):</label>
                    <p-inputNumber [(ngModel)]="specificMinute" [min]="0" [max]="59"
                        (onInput)="onSpecificValueChange()">
                    </p-inputNumber>
                </div>
            </div>
        </p-tabPanel>

        <!-- Hours Tab -->
        <p-tabPanel header="Heures">
            <div class="flex flex-column gap-2">
                <label>Sélectionnez l'option pour les heures:</label>
                <div class="flex flex-row gap-2 mt-3" *ngFor="let option of hoursOptions">
                    <p-radioButton [value]="option.value" [(ngModel)]="selectedHoursOption"
                        [inputId]="'hour_' + option.value" (onClick)="onHoursChange()">
                    </p-radioButton>
                    <label [for]="'hour_' + option.value">{{ option.label }}</label>
                </div>
                <div class="flex flex-column gap-2 mt-3" *ngIf="selectedHoursOption === 'custom'">
                    <label>Heure spécifique (0-23):</label>
                    <p-inputNumber [(ngModel)]="specificHour" [min]="0" [max]="23" (onInput)="onSpecificValueChange()">
                    </p-inputNumber>
                </div>
            </div>
        </p-tabPanel>

        <!-- Days Tab -->
        <p-tabPanel header="Jours">
            <div class="flex flex-column gap-2">
                <label>Sélectionnez l'option pour les jours:</label>
                <div class="flex flex-row gap-2 mt-3" *ngFor="let option of daysOptions">
                    <p-radioButton [value]="option.value" [(ngModel)]="selectedDaysOption"
                        [inputId]="'day_' + option.value" (onClick)="onDaysChange()">
                    </p-radioButton>
                    <label [for]="'day_' + option.value">{{ option.label }}</label>
                </div>

                <div class="flex flex-column gap-2 mt-3" *ngIf="selectedDaysOption === 'dom'">
                    <label>Jour spécifique du mois (1-31):</label>
                    <p-inputNumber [(ngModel)]="specificDayOfMonth" [min]="1" [max]="31"
                        (onInput)="onSpecificValueChange()">
                    </p-inputNumber>
                    <small class="text-sm text-blue-500">Le jour de la semaine sera défini sur '?' automatiquement.</small>
                </div>

                <div class="flex flex-column gap-2 mt-3" *ngIf="selectedDaysOption === 'dow'">
                    <label>Jour de la semaine:</label>
                    <p-dropdown [options]="weekdays" [(ngModel)]="specificDayOfWeek" optionLabel="label"
                        optionValue="value" (onChange)="onSpecificValueChange()">
                    </p-dropdown>
                    <small class="text-sm text-blue-500">Le jour du mois sera défini sur '?' automatiquement.</small>
                </div>
            </div>
        </p-tabPanel>

        <!-- Month Tab -->
        <p-tabPanel header="Mois">
            <div class="flex flex-column gap-2">
                <label>Mois:</label>
                <p-dropdown [options]="months" [(ngModel)]="specificMonth" optionLabel="label" optionValue="value"
                    (onChange)="onSpecificValueChange()">
                </p-dropdown>
            </div>
        </p-tabPanel>

        <!-- Presets Tab -->
        <p-tabPanel header="Préconfigurations">
            <div class="flex flex-column gap-2">
                <label>Préconfigurations communes:</label>
                <div class="flex flex-row flex-wrap gap-2 mt-3">
                    <p-button label="Minuit (tous les jours)" styleClass="p-button-sm mr-2 mb-2"
                        (onClick)="usePreset('0 0 0 * * ?')"></p-button>
                    <p-button label="Midi (tous les jours)" styleClass="p-button-sm mr-2 mb-2"
                        (onClick)="usePreset('0 0 12 * * ?')"></p-button>
                    <p-button label="Chaque heure" styleClass="p-button-sm mr-2 mb-2"
                        (onClick)="usePreset('0 0 * * * ?')"></p-button>
                    <p-button label="Chaque minute" styleClass="p-button-sm mr-2 mb-2"
                        (onClick)="usePreset('0 * * * * ?')"></p-button>
                    <p-button label="Toutes les 5 minutes" styleClass="p-button-sm mr-2 mb-2"
                        (onClick)="usePreset('0 */5 * * * ?')"></p-button>
                    <p-button label="Lundi à minuit" styleClass="p-button-sm mr-2 mb-2"
                        (onClick)="usePreset('0 0 0 ? * 1')"></p-button>
                    <p-button label="Premier du mois à minuit" styleClass="p-button-sm mr-2 mb-2"
                        (onClick)="usePreset('0 0 0 1 * ?')"></p-button>
                    <p-button label="Dimanche à minuit" styleClass="p-button-sm mr-2 mb-2"
                        (onClick)="usePreset('0 0 0 ? * 0')"></p-button>
                    <p-button label="Premier janvier à minuit" styleClass="p-button-sm mr-2 mb-2"
                        (onClick)="usePreset('0 0 0 1 1 ?')"></p-button>
                </div>
            </div>
        </p-tabPanel>
    </p-tabView>
</div>